import { Send } from "@mui/icons-material";
import { Box } from "@mui/material";
import Picker from "emoji-picker-react";
import React from "react";
import TextArea from "../../../atoms/TextArea";

interface CommentInputProps {
  newCommentText: string;
  setNewCommentText: (text: string) => void;
  onSubmit: (data?: any) => void;
  showEmojiPicker: boolean;
  setShowEmojiPicker: (show: boolean) => void;
  onEmojiSelect: (emoji: any) => void;
}

const CommentInput: React.FC<CommentInputProps> = ({
  newCommentText,
  setNewCommentText,
  onSubmit,
  showEmojiPicker,
  setShowEmojiPicker,
  onEmojiSelect,
}) => {
  return (
    <>
      {/* Fixed Comment Input Area */}
      <Box
        className="new-comment"
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          height: '90px', // Fixed height
          zIndex: 10,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* TextArea Container with integrated Send button */}
        <Box
          sx={{
            position: "relative",
            width: "100%",
            maxWidth: "400px", // Reduced from 600px to 400px
          }}
        >
          <TextArea
            value={newCommentText}
            onChange={(e: any) => setNewCommentText(e.target.value)}
            placeholder="Neue Nachricht..."
            rows={2}
            sx={{
              width: "100%",
            }}
          />
          
          {/* <Button
            onClick={() => setShowEmojiPicker(!showEmojiPicker)}
            sx={{
              position: "absolute",
              top: "50%",
              right: "50px",
              transform: "translateY(-50%)",
              minWidth: "30px",
              height: "30px",
              padding: "4px",
              fontSize: "16px",
            }}
          >
            😊
          </Button> */}
          
          {/* Send Button */}
          <Send
            onClick={() => onSubmit()}
            sx={{
              position: "absolute",
              top: "50%",
              right: "12px",
              transform: "translateY(-50%)",
              height: "24px",
              width: "24px",
              cursor: "pointer",
              color: newCommentText.trim() ? "#1976d2" : "#ccc",
              transition: "color 0.2s",
              "&:hover": {
                color: newCommentText.trim() ? "#1565c0" : "#ccc",
              },
            }}
          />
        </Box>
      </Box>

      {/* Emoji Picker */}
      {showEmojiPicker && (
        <Picker
          style={{
            position: "absolute",
            top: "400px",
            right: "8px",
            zIndex: 9999,
            width: "300px",
            height: "300px",
            overflow: "scroll",
          }}
          onEmojiClick={onEmojiSelect}
        />
      )}
    </>
  );
};

export default CommentInput;